import { NewPayouts } from "./newPayouts.model";

export class NewData {
    isVerestroEnabledYN: string;
    constructor(
        public isVerificationYN: string = "",
        public isCashInYN: string = "",
        public isCashOutYN: string = "",
        public payouts: NewPayouts = new NewPayouts(),
        public isGamingYN: string = "",
        public isTopUpAllowedYN: string = "",
        public isReferralModuleEnabledYN: string = "",
        public isEdufocalModuleEnabledYN: string = "",
        public isReadyCreditYN: string = "",
        public isBlinkSkyYN: string = "",
        public isFintechFlowBillPaymentEnableYN: string = "",
        public isRiaMoneyTransferAllowedYN: string = "",
        public isFintechDigicelBillPaymentEnableYN: string = "",
        public isFintechJpsBillPaymentEnableYN: string = "",
        public isFintechJpsPrepaidBillPaymentEnableYN: string = "",
        public isFintechNwcBillPaymentEnableYN: string = "",
        public isHorseRacingEnabledYN: string = "",
        public isSportsBettingAllowed: string = "",
        public isSportBettingPayoutYN: string = "",
        public isHorceRacingPayoutYN: string = "",
        public ipBlockingYN: string = "",
        public cashierAutomaticFundTransfer: string = "",
        public isDisabledYN: string = "",
        public isAiChatBotEnabledYN: string = "",
        public automaticFundTransfer: String = '',
        public isPostToPost: String = '',
        public sendInvoiceEmail: String = '',
        public topUpNotificationYN: String = '',
        public billPaymentNotificationYN: String = '',
        public riaSendNotificationYN: String = '',
        public isVerestroAllowed: String = "",
        public kioskCommission: number = null,
        public isKioskEnabledYN: string = "",
        public isKioskPayoutEnabledYN: string = "",
        public isAutomaticCommissionEnabled: string = "",
        public commissionPercentage: number = null,
        public isApiUser: string = "",
        public isBillPaymentEnabledYn: string = "",
    ) { }
}